module.exports = __webpack_public_path__ + "img/error-ticket.e354a9b1.png";